<template>
	<div class="footer-container">
		<div class="footer-content">
			<img
				:src="require('@/common/assets/icons/drc-logo.svg')"
				alt="drc-footer"
			>
			<ul class="footer-options">
				<li @click="redirectToResources()">{{$t('common.footer.resources')}}</li>
				<li @click="handleReportDialogShow($event)" id="report">
					{{ $t('common.footer.reportProblem')}}
					<ReportAProblem
						v-if="showSendReportDialog"
						@closeDialog="handleReportDialogClose"
						@handleMessage="sendEmailForProblem"
						:title="`${ $t('projectPage.what')}`"
						:sending="sending"
					/>
				</li>
				<li>
					<a href="mailto:pavlina.venkova@akkodis.com">{{$t('common.footer.contactCMT')}}</a>
				</li>
			</ul>
			<span>© 2025 Akkodis. All rights reserved.</span>
		</div>
	</div>
</template>

<script>
import ReportAProblem from "@/drc/components/ReportAProblem.vue";
import reportAProblemMixin from "@/drc/mixins/report-a-problem-mixin";

export default {
	name: "Footer",
	mixins: [reportAProblemMixin],
	components: {
		ReportAProblem,
	},
	methods: {
		redirectToResources() {
			this.$router.push("/resources")
		},
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.footer-container {
	background: white;
	text-align: center;
	width: 100%;
	min-height: 240px;
	margin-top: auto;
	padding-left: 6%;
	padding-right: 6%;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;

	.footer-content {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 30px;
		max-width: 1440px;
		margin: 0 auto;
		align-self: center;

		img {
			width: 245px;
		}

		.footer-options {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			width: fit-content;
			align-items: flex-start;
			margin: 0;
			padding: 0;
			gap: 25px;

			@media (max-width: $mobile) {
				flex-direction: column;
			}

			li {
				color: black;
				cursor: pointer;
				list-style-type: none;
				font-family: Roboto, sans-serif;
				font-size: 15px;
				font-weight: 400;
				line-height: 18px;
				text-align: left;

				a {
					color: black;
					font-family: Roboto, sans-serif;
					font-size: 15px;
					font-weight: 400;
					line-height: 18px;
				}

				&:hover {
					color: #FDB71A;

					a {
						color: #FDB71A;
					}
				}
			}
		}

		span {
			color: black;
			text-align: start;
			font-family: Roboto, sans-serif;
			font-size: 15px;
			font-weight: 400;
			line-height: 18px;
		}
	}

}
</style>
